module.exports = __webpack_public_path__ + "src/assets/models/spectrophotometer/tt_stand_3.fbx";